import { render, staticRenderFns } from "./BtnRound.vue?vue&type=template&id=36b13a3e&"
import script from "./BtnRound.vue?vue&type=script&lang=js&"
export * from "./BtnRound.vue?vue&type=script&lang=js&"
import style0 from "./BtnRound.vue?vue&type=style&index=0&id=36b13a3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports